// Multi-day appointment helpers (Sprint 9)

// An appointment is multi-day if its end date (day-precision) is strictly after its start date.
// End == 00:00 of next day counts as SAME day (excluded from multi-day).
export function isMultiDay(a) {
  const s = new Date(a.start);
  const e = new Date(a.end);
  const startDay = new Date(s.getFullYear(), s.getMonth(), s.getDate()).getTime();
  const endInclusive = new Date(e.getTime() - 1);
  const endDay = new Date(endInclusive.getFullYear(), endInclusive.getMonth(), endInclusive.getDate()).getTime();
  return endDay > startDay;
}

export function dayIndex(d, weekStart) {
  const s = new Date(weekStart);
  s.setHours(0, 0, 0, 0);
  const day = new Date(d);
  day.setHours(0, 0, 0, 0);
  return Math.floor((day - s) / 86400000);
}

// Splits appointments into { allDay: [multi-day], slotted: [single-day] }
export function splitAppointments(list) {
  const allDay = [];
  const slotted = [];
  for (const a of list) {
    if (isMultiDay(a)) allDay.push(a);
    else slotted.push(a);
  }
  return { allDay, slotted };
}

// Simple lane layout: assign each multi-day appointment a lane so overlapping ones stack vertically.
export function assignLanes(items) {
  // items: [{a, startIdx, endIdx}] - endIdx exclusive
  const lanes = []; // lanes[i] = endIdx currently occupied
  const out = [];
  const sorted = [...items].sort((x, y) => x.startIdx - y.startIdx || x.endIdx - y.endIdx);
  for (const it of sorted) {
    let lane = -1;
    for (let i = 0; i < lanes.length; i++) {
      if (lanes[i] <= it.startIdx) { lane = i; lanes[i] = it.endIdx; break; }
    }
    if (lane === -1) { lanes.push(it.endIdx); lane = lanes.length - 1; }
    out.push({ ...it, lane });
  }
  return { placed: out, laneCount: Math.max(1, lanes.length) };
}
